import { Button, message, Modal, Pagination, Spin, Table } from "antd";
import axios from "axios";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import Barcode from "react-barcode";
import { Col, Row } from "react-bootstrap";
import { AiOutlineCloseCircle } from "react-icons/ai";
import ReactToPrint from "react-to-print";
import documentloader from "../../../Assets/Images/awbcustomsloader.gif";
import Companyseal from "../../../Assets/Images/seal.JPG";
import { API, Headers } from "../../../Config";
import { POST } from "../../../Config/ApiRequests";

function PrintCustomInvoicePdf(props) {
  const componentRef = useRef();
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [Loading, setLoading] = useState(false);
  const [LoadingPdf, setLoadingPdf] = useState(false);
  const [exchangeData, setexchangeData] = useState([]);
  const [USD, setUsd] = useState(0);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [showExcel, setShowExcel] = useState(false);
  const [meta, setMeta] = useState({});
  const [page, setPage] = useState(1);
  const [take, setTake] = useState(10);
  const [isLoading2, setIsLoading2] = useState(false);
  const [selectedRate, setSelectedRate] = useState({});
  const [exchangeRates, setexchangeRates] = useState([]);

  // CSS styles for PDF rendering
  const pdfStyles = `
    @media print {
      * {
        -webkit-print-color-adjust: exact !important;
        color-adjust: exact !important;
        print-color-adjust: exact !important;
      }
      
      .print-customer-invoice-pdf-txt {
        color: #000 !important;
        visibility: visible !important;
        opacity: 1 !important;
        display: block !important;
      }
      
      .print-customs-table,
      .print-invoice-table {
        border-collapse: collapse !important;
        width: 100% !important;
      }
      
      .print-customs-table td,
      .print-invoice-table td,
      .print-customs-table th,
      .print-invoice-table th {
        border: 1px solid #000 !important;
        padding: 2px !important;
        font-size: 9px !important;
        line-height: 1.2 !important;
        color: #000 !important;
      }
      
      .print-customs-page {
        width: 210mm !important;
        min-height: 297mm !important;
        margin: 0 !important;
        padding: 5mm !important;
        box-sizing: border-box !important;
        background: white !important;
        page-break-after: avoid !important;
      }

      .page-break {
        page-break-after: always !important;
        break-after: page !important;
      }

      .no-page-break {
        page-break-after: avoid !important;
        break-after: avoid !important;
      }
    }
    
    /* Ensure text visibility in all cases */
    .print-customer-invoice-pdf-txt {
      color: #000 !important;
      font-weight: normal !important;
      text-decoration: none !important;
    }
    
    /* Force table visibility */
    .print-invoice-table-td {
      background-color: transparent !important;
      color: #000 !important;
    }
  `;

  // Inject CSS for PDF rendering
  useEffect(() => {
    const styleElement = document.createElement("style");
    styleElement.innerHTML = pdfStyles;
    document.head.appendChild(styleElement);

    return () => {
      if (document.head.contains(styleElement)) {
        document.head.removeChild(styleElement);
      }
    };
  }, []);

  // Function to calculate how many items can fit on the first page
  const calculateItemsPerPage = (totalItems) => {
    if (totalItems <= 30) {
      return totalItems;
    } else if (totalItems <= 40) {
      return 30;
    } else if (totalItems <= 50) {
      return 35;
    } else {
      return 40;
    }
  };

  // Function to split items into pages with smart logic
  const splitItemsIntoPages = (items) => {
    const totalItems = items.length;

    if (totalItems <= 30) {
      return {
        firstPageItems: items,
        remainingItems: [],
        hasMultiplePages: false,
      };
    }

    const itemsPerFirstPage = calculateItemsPerPage(totalItems);
    const firstPageItems = items.slice(0, itemsPerFirstPage);
    const remainingItems = items.slice(itemsPerFirstPage);

    return {
      firstPageItems,
      remainingItems,
      hasMultiplePages: remainingItems.length > 0,
    };
  };

  // Function to render items table
  const renderItemsTable = (
    items,
    startIndex = 0,
    isFirstPage = true,
    basicValue = 0,
    frieghtValue = 0,
    InsuranceValue = 0,
    totalValue = 0
  ) => {
    // Sort items: numerically if item is a number, alphabetically otherwise
    const sortedItems = [...items].sort((a, b) => {
      const itemA = a.item.toString().trim();
      const itemB = b.item.toString().trim();

      // Check if both items are numeric
      const isNumericA = !isNaN(parseFloat(itemA)) && isFinite(itemA);
      const isNumericB = !isNaN(parseFloat(itemB)) && isFinite(itemB);

      if (isNumericA && isNumericB) {
        // Sort numerically
        return parseFloat(itemA) - parseFloat(itemB);
      } else {
        // Sort alphabetically (case-insensitive)
        return itemA.localeCompare(itemB, undefined, { sensitivity: "base" });
      }
    });

    const totalItems = sortedItems.length;
    const itemsPerColumn = Math.ceil(totalItems / 3);

    return (
      <table className="print-invoice-table">
        <tr>
          <td colSpan={3} style={{ border: "none" }}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-start",
                gap: "0px",
                margin: "0",
                padding: "0",
              }}
            >
              <table
                className="print-invoice-table"
                style={{
                  width: "33%",
                  margin: "0",
                  padding: "0",
                  borderSpacing: "0",
                }}
              >
                <tr>
                  <th
                    className="print-customs-td"
                    style={{
                      width: "70%",
                      borderBottom: "1px solid #bfbfbf",
                      margin: "0",
                      padding: "2px",
                    }}
                  >
                    <div
                      className="print-customsInvoice-txt5 print-customer-invoice-pdf-txt"
                      style={{ fontSize: "10px", color: "#000" }}
                    >
                      Description
                    </div>
                  </th>
                  <th
                    className="print-customs-td"
                    style={{
                      width: "15%",
                      borderBottom: "1px solid #bfbfbf",
                      margin: "0",
                      padding: "2px",
                    }}
                  >
                    <div
                      className="print-customsInvoice-txt5 print-customer-invoice-pdf-txt"
                      style={{ fontSize: "10px", color: "#000" }}
                    >
                      Qty
                    </div>
                  </th>
                  <th
                    className="print-customs-td"
                    style={{
                      width: "20%",
                      borderBottom: "1px solid #bfbfbf",
                      margin: "0",
                      padding: "2px",
                    }}
                  >
                    <div
                      className="print-customsInvoice-txt5 print-customer-invoice-pdf-txt"
                      style={{ fontSize: "10px", color: "#000" }}
                    >
                      Value
                    </div>
                  </th>
                </tr>
                {sortedItems.slice(0, itemsPerColumn).map((item, index) => (
                  <tr key={item.id || index}>
                    <td
                      className="print-invoice-table-td"
                      style={{
                        width: "70%",
                        margin: "0",
                        padding: "1px",
                      }}
                    >
                      <div
                        className="print-customsInvoice-txt6 print-customer-invoice-pdf-txt"
                        style={{
                          fontSize: "9px",
                          lineHeight: "1.1",
                          color: "#000",
                        }}
                      >
                        {startIndex + index + 1}. {item.item}
                      </div>
                    </td>
                    <td
                      className="print-invoice-table-td"
                      style={{
                        width: "10%",
                        margin: "0",
                        padding: "1px",
                      }}
                    >
                      <div
                        className="print-customsInvoice-txt6 print-customer-invoice-pdf-txt"
                        style={{ color: "#000" }}
                      >
                        {item.quantity}
                      </div>
                    </td>
                    <td
                      className="print-invoice-table-td"
                      style={{
                        width: "20%",
                        margin: "0",
                        padding: "1px",
                      }}
                    >
                      <div
                        className="print-customsInvoice-txt6 print-customer-invoice-pdf-txt"
                        style={{ color: "#000" }}
                      >
                        {Number(
                          Number(item.value) *
                            item.quantity *
                            Number(selectedRate?.sar_usd)
                        ).toFixed(2)}
                      </div>
                    </td>
                  </tr>
                ))}
              </table>
              <table
                className="print-invoice-table"
                style={{
                  width: "33%",
                  margin: "0",
                  padding: "0",
                  borderSpacing: "0",
                }}
              >
                <tr>
                  <th
                    className="print-customs-td"
                    style={{
                      width: "70%",
                      borderBottom: "1px solid #bfbfbf",
                      margin: "0",
                      padding: "2px",
                    }}
                  >
                    <div
                      className="print-customsInvoice-txt5 print-customer-invoice-pdf-txt"
                      style={{ fontSize: "10px", color: "#000" }}
                    >
                      Description
                    </div>
                  </th>
                  <th
                    className="print-customs-td"
                    style={{
                      width: "15%",
                      borderBottom: "1px solid #bfbfbf",
                      margin: "0",
                      padding: "2px",
                    }}
                  >
                    <div
                      className="print-customsInvoice-txt5 print-customer-invoice-pdf-txt"
                      style={{ fontSize: "10px", color: "#000" }}
                    >
                      Qty
                    </div>
                  </th>
                  <th
                    className="print-customs-td"
                    style={{
                      width: "20%",
                      borderBottom: "1px solid #bfbfbf",
                      margin: "0",
                      padding: "2px",
                    }}
                  >
                    <div
                      className="print-customsInvoice-txt5 print-customer-invoice-pdf-txt"
                      style={{ fontSize: "10px", color: "#000" }}
                    >
                      Value
                    </div>
                  </th>
                </tr>
                {sortedItems
                  .slice(itemsPerColumn, itemsPerColumn * 2)
                  .map((item, index) => (
                    <tr key={item.id || index + itemsPerColumn}>
                      <td
                        className="print-invoice-table-td"
                        style={{
                          width: "70%",
                          margin: "0",
                          padding: "1px",
                        }}
                      >
                        <div
                          className="print-customsInvoice-txt6 print-customer-invoice-pdf-txt"
                          style={{ color: "#000" }}
                        >
                          {startIndex + index + itemsPerColumn + 1}. {item.item}
                        </div>
                      </td>
                      <td
                        className="print-invoice-table-td"
                        style={{
                          width: "10%",
                          margin: "0",
                          padding: "1px",
                        }}
                      >
                        <div
                          className="print-customsInvoice-txt6 print-customer-invoice-pdf-txt"
                          style={{ color: "#000" }}
                        >
                          {item.quantity}
                        </div>
                      </td>
                      <td
                        className="print-invoice-table-td"
                        style={{
                          width: "20%",
                          margin: "0",
                          padding: "1px",
                        }}
                      >
                        <div
                          className="print-customsInvoice-txt6 print-customer-invoice-pdf-txt"
                          style={{ color: "#000" }}
                        >
                          {Number(
                            Number(item.value) *
                              item.quantity *
                              Number(selectedRate?.sar_usd)
                          ).toFixed(2)}
                        </div>
                      </td>
                    </tr>
                  ))}
              </table>
              <table
                className="print-invoice-table"
                style={{
                  width: "33%",
                  margin: "0",
                  padding: "0",
                  borderSpacing: "0",
                }}
              >
                <tr>
                  <th
                    className="print-customs-td"
                    style={{
                      width: "70%",
                      borderBottom: "1px solid #bfbfbf",
                      margin: "0",
                      padding: "2px",
                    }}
                  >
                    <div
                      className="print-customsInvoice-txt5 print-customer-invoice-pdf-txt"
                      style={{ fontSize: "10px", color: "#000" }}
                    >
                      Description
                    </div>
                  </th>
                  <th
                    className="print-customs-td"
                    style={{
                      width: "15%",
                      borderBottom: "1px solid #bfbfbf",
                      margin: "0",
                      padding: "2px",
                    }}
                  >
                    <div
                      className="print-customsInvoice-txt5 print-customer-invoice-pdf-txt"
                      style={{ fontSize: "10px", color: "#000" }}
                    >
                      Qty
                    </div>
                  </th>
                  <th
                    className="print-customs-td"
                    style={{
                      width: "20%",
                      borderBottom: "1px solid #bfbfbf",
                      margin: "0",
                      padding: "2px",
                    }}
                  >
                    <div
                      className="print-customsInvoice-txt5 print-customer-invoice-pdf-txt"
                      style={{ fontSize: "10px", color: "#000" }}
                    >
                      Value
                    </div>
                  </th>
                </tr>
                {sortedItems.slice(itemsPerColumn * 2).map((item, index) => (
                  <tr key={item.id || index + itemsPerColumn * 2}>
                    <td
                      className="print-invoice-table-td"
                      style={{
                        width: "70%",
                        margin: "0",
                        padding: "1px",
                      }}
                    >
                      <div
                        className="print-customsInvoice-txt6 print-customer-invoice-pdf-txt"
                        style={{ color: "#000" }}
                      >
                        {startIndex + index + itemsPerColumn * 2 + 1}.{" "}
                        {item.item}
                      </div>
                    </td>
                    <td
                      className="print-invoice-table-td"
                      style={{
                        width: "10%",
                        margin: "0",
                        padding: "1px",
                      }}
                    >
                      <div
                        className="print-customsInvoice-txt6 print-customer-invoice-pdf-txt"
                        style={{ color: "#000" }}
                      >
                        {item.quantity}
                      </div>
                    </td>
                    <td
                      className="print-invoice-table-td"
                      style={{
                        width: "20%",
                        margin: "0",
                        padding: "1px",
                      }}
                    >
                      <div
                        className="print-customsInvoice-txt6 print-customer-invoice-pdf-txt"
                        style={{ color: "#000" }}
                      >
                        {Number(
                          Number(item.value) *
                            item.quantity *
                            Number(selectedRate?.sar_usd)
                        ).toFixed(2)}
                      </div>
                    </td>
                  </tr>
                ))}
              </table>
            </div>
          </td>
        </tr>
        {isFirstPage && (
          <tr>
            <td
              colSpan={3}
              style={{
                padding: "5px 0",
                textAlign: "center",
              }}
            >
              <table
                style={{
                  width: "100%",
                  borderCollapse: "collapse",
                  border: "1px solid lightgrey",
                }}
              >
                <tr>
                  <td
                    style={{
                      border: "1px solid lightgrey",
                      textAlign: "center",
                    }}
                  >
                    <div
                      className="print-customsInvoice-txt5 print-customer-invoice-pdf-txt"
                      style={{ color: "#000" }}
                    >
                      Basic Value: {basicValue}
                    </div>
                  </td>
                  <td
                    style={{
                      border: "1px solid lightgrey",
                      textAlign: "center",
                    }}
                  >
                    <div
                      className="print-customsInvoice-txt5 print-customer-invoice-pdf-txt"
                      style={{ color: "#000" }}
                    >
                      Freight @ 20%: {frieghtValue}
                    </div>
                  </td>
                  <td
                    style={{
                      border: "1px solid lightgrey",
                      textAlign: "center",
                    }}
                  >
                    <div
                      className="print-customsInvoice-txt5 print-customer-invoice-pdf-txt"
                      style={{ color: "#000" }}
                    >
                      Insurance @ 1.125%: {InsuranceValue}
                    </div>
                  </td>
                  <td
                    style={{
                      border: "1px solid lightgrey",
                      textAlign: "center",
                    }}
                  >
                    <div
                      className="print-customsInvoice-txt5 print-customer-invoice-pdf-txt"
                      style={{ color: "#000" }}
                    >
                      Total Value: ${totalValue}
                    </div>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
        )}
      </table>
    );
  };

  // Function to render terms and conditions
  const renderTermsAndConditions = (item) => (
    <tr>
      <td colSpan={6}>
        <div
          className="print-invoice-txt5 print-customer-invoice-pdf-txt"
          style={{
            margin: "1px 0",
            fontSize: "8px",
            lineHeight: "1.2",
            color: "#000",
          }}
        >
          1. I.Mr/Mrs <b>{item.iqama_name}</b>
          ID:<b>{item.iqama_number}</b>
          for my family/friends, personal use as gift.not for sale. Shipper also
          declare that he is liable of any customs duty/fine / penalites against
          this shipment at origin and destination
        </div>
        <div
          className="print-invoice-txt5 print-customer-invoice-pdf-txt"
          style={{
            margin: "1px 0",
            fontSize: "8px",
            lineHeight: "1.2",
            color: "#000",
          }}
        >
          2. Shipper certifies that the particulars on the face here of are
          correct and that insofar as any part of the consignemt contains
          Dangerous Goods if any surch part is property by name and is in proper
          condition for carriage by air according to the Internation Transport
          Association's applicable dangerous goods regulations and civil
          Aviation Regulation of the United Arab Emirates.
        </div>
        <div
          className="print-invoice-txt5 print-customer-invoice-pdf-txt"
          style={{
            margin: "1px 0",
            fontSize: "8px",
            lineHeight: "1.2",
            color: "#000",
          }}
        >
          3. I/We agree that standard terms and conditions apply for this
          shipment and liability to terms and conditions. Warsaw Convention amy
          apply. I/We Service Liability shall not exceed US$100 for any
          shipment.
        </div>
        <div
          className="print-invoice-txt5 print-customer-invoice-pdf-txt"
          style={{
            margin: "1px 0",
            fontSize: "8px",
            lineHeight: "1.2",
            color: "#000",
          }}
        >
          4. /The Shipper also here by authorize forward the shipment in full or
          part their convenience
        </div>
        <div
          className="print-invoice-txt5 print-customer-invoice-pdf-txt"
          style={{
            margin: "1px 0",
            fontSize: "8px",
            lineHeight: "1.2",
            color: "#000",
          }}
        >
          5. The Shipper also here by authorize and their Counterpart India to
          clear the parcel on behalf of me and same should be delivered to the
          Consignee address.
        </div>
      </td>
    </tr>
  );

  // Function to render signature and seal
  const renderSignatureAndSeal = (item) => (
    <tr>
      <td
        colSpan={3}
        style={{
          height: "12vh",
          verticalAlign: "top",
        }}
      >
        <div
          className="print-customsInvoice-txt4 print-customer-invoice-pdf-txt"
          style={{ color: "#000" }}
        >
          Customer Signature
        </div>
        {item.signature ? (
          <div
            style={{
              display: "block",
              marginTop: "5px",
            }}
          >
            <img src={item.signature} height="80px" width="80px" />
          </div>
        ) : null}
      </td>
      <td
        colSpan={3}
        style={{
          height: "12vh",
          verticalAlign: "top",
          textAlign: "right",
          paddingRight: "20px",
        }}
      >
        <div
          className="print-customsInvoice-txt4 print-customer-invoice-pdf-txt"
          style={{
            textAlign: "right",
            marginBottom: "5px",
            color: "#000",
          }}
        >
          Company SEAL
        </div>
        <div
          className="print-customs-seal"
          style={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "flex-start",
            flexDirection: "row",
            gap: "5px",
            width: "100%",
          }}
        >
          <div style={{ textAlign: "right" }}>
            <img
              src={Companyseal}
              height="80px"
              width="80px"
              style={{
                display: "block",
                marginLeft: "auto",
              }}
            />
          </div>
          {item.collection && item.collection.driver_signature ? (
            <div style={{ textAlign: "right" }}>
              <img
                src={item.collection && item.collection.driver_signature}
                height="80px"
                width="80px"
                style={{
                  display: "block",
                  marginLeft: "auto",
                }}
              />
            </div>
          ) : null}
        </div>
      </td>
    </tr>
  );

  useEffect(() => {
    loadBoxesViaAwb();
  }, []);

  useEffect(() => {
    getExchangeRates(1, 10);
  }, []);

  const getExchangeRates = async (_page, _take) => {
    try {
      setIsLoading2(true);
      let api = API.EXCHANGE_RATE_LIST;
      let obj = {
        page: _page,
        take: _take,
      };
      const excData = await POST(api, obj);
      if (excData?.status) {
        setexchangeRates(excData?.data);
        setSelectedRate(excData?.data[0]);
        setMeta(excData?.meta);
        setIsLoading2(false);
      } else {
        message.error("No data found");
        setIsLoading2(false);
      }
    } catch (err) {
      message.error("Oops.Something went");
      setIsLoading2(false);
    }
  };

  const onSelectChange = (newSelectedRowKeys, rowDetails) => {
    console.log(newSelectedRowKeys);
    console.log(rowDetails[0]);
    setSelectedRate(rowDetails[0]);
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const columns = [
    {
      title: "From Date",
      dataIndex: "from_date",
      key: "from_date",
      render: (text) => <a>{moment(text).format("ll")}</a>,
    },
    {
      title: "To Date",
      dataIndex: "to_date",
      key: "to_date",
      render: (text) => <a>{moment(text).format("ll")}</a>,
    },
    {
      title: "SAR - USD",
      dataIndex: "sar_usd",
      key: "sar_usd",
      render: (text) => <a>{text}</a>,
    },
    {
      title: "SAR - INR",
      dataIndex: "sar_inr",
      key: "sar_inr",
      render: (text) => <a>{text}</a>,
    },
    {
      title: "INR - SAR",
      dataIndex: "inr_sar",
      key: "inr_sar",
      render: (text) => <a>{text}</a>,
    },
  ];

  const fetchData = async () => {
    try {
      const USD = await GetCurrancy();
      const boxes = await loadBoxesViaAwb(USD?.result);
      setShowExcel(true);
    } catch (error) {
      console.error(error);
      message.error("Select a rate");
    }
  };

  const GetCurrancy = async () => {
    if (selectedRate?.id) {
      let val = selectedRate["sar_usd"];
      console.log(val);
      return val;
    } else {
      message.error("Select a rate");
    }
  };

  const loadBoxesViaAwb = () => {
    const AWBID = props.selected && props.selected[0].id;
    let URL = API.BASR_URL + API.BOXES_VIA_AWB + AWBID;
    axios
      .get(URL, {
        headers: Headers(),
      })
      .then(function (response) {
        if (response.status === 200) {
          let data = response.data;
          setData(data);
          setIsLoading(false);
        } else {
          message.error("Ooops. Something went wrong...!");
          setIsLoading(false);
        }
      });
  };

  // Custom sorting function for box_number
  const sortBoxNumber = (a, b) => {
    const boxA = a.box_number.toString().trim();
    const boxB = b.box_number.toString().trim();

    // Sort alphanumerically in ascending order
    return boxA.localeCompare(boxB, undefined, {
      numeric: true,
      sensitivity: "base",
    });
  };

  // Enhanced PDF download function
  const downloadPdf = async () => {
    setLoadingPdf(true);
    try {
      const pdf = new jsPDF({
        orientation: "portrait",
        unit: "mm",
        format: "a4",
      });

      let isFirstPdf = true;

      for (let i = 0; i < data.length; i++) {
        const currentPage = data[i];
        setData([currentPage]);

        // Wait for proper rendering
        await new Promise((resolve) => setTimeout(resolve, 300));

        const content = componentRef.current;

        const canvas = await html2canvas(content, {
          useCORS: true,
          allowTaint: true,
          scale: 1.5,
          width: 794,
          height: 1123,
          windowWidth: 1200,
          windowHeight: 1600,
          backgroundColor: "#ffffff",
          removeContainer: false,
          imageTimeout: 10000,
          logging: false,
        });

        const imgData = canvas.toDataURL("image/png", 0.8);
        const imgWidth = 210;
        const pageHeight = 297;
        const imgHeight = (canvas.height * imgWidth) / canvas.width;

        // Add page only if not the first iteration
        if (!isFirstPdf) {
          pdf.addPage();
        }
        isFirstPdf = false;

        // Add the image to fit the page
        pdf.addImage(
          imgData,
          "PNG",
          0,
          0,
          imgWidth,
          Math.min(pageHeight, imgHeight)
        );
      }

      setData([...data]); // Restore original data
      pdf.save("sahari_awb.pdf");
    } catch (error) {
      console.error("Error capturing pages:", error);
      message.error("Error generating PDF. Please try again.");
    }
    loadBoxesViaAwb();
    setLoadingPdf(false);
  };

  return (
    <div>
      <Modal
        visible={props.visible}
        width={850}
        onCancel={props.onClose}
        footer={false}
      >
        {data.length ? (
          <ReactToPrint
            trigger={() => <Button type="primary">Print</Button>}
            content={() => componentRef.current}
            pageStyle="@page { size: A4; margin: 0mm; }"
          />
        ) : null}
        &nbsp;
        {data.length ? (
          <Button type="primary" onClick={downloadPdf}>
            {LoadingPdf ? <Spin /> : "Download PDF"}
          </Button>
        ) : null}
        {!showExcel ? (
          <>
            <div className="modal-table-header">Select Rate</div>
            <div
              style={{
                height: "300px",
                width: "100%",
                overflow: "scroll",
              }}
            >
              <>
                <Table
                  rowKey="id"
                  size="small"
                  pagination={false}
                  columns={columns}
                  rowSelection={{ type: "radio", ...rowSelection }}
                  dataSource={exchangeRates}
                />
                <br />
                <Pagination
                  total={meta?.total_count}
                  showSizeChanger
                  defaultCurrent={meta?.page}
                  showTotal={(total) => `Total ${meta?.total_count}`}
                  onChange={(page, pageSize) => {
                    setPage(page);
                    setTake(pageSize);
                    getExchangeRates(page, pageSize);
                  }}
                />
              </>
            </div>
            <br />
          </>
        ) : null}
        <div
          ref={componentRef}
          style={{
            width: "100%",
            backgroundColor: "white",
            color: "black",
            fontFamily: "Arial, sans-serif",
          }}
        >
          {isLoading ? (
            <div className="print-customs-box">
              <img src={documentloader} />
            </div>
          ) : (
            <>
              {data && data.length ? (
                <>
                  {data
                    .sort(sortBoxNumber) // Updated sorting with custom function
                    .map((item, itemIndex) => {
                      let basicValue = Number(
                        item?.boxe_item?.reduce(function (tot, arr) {
                          return (
                            Number(tot) +
                            Number(
                              arr.value *
                                arr.quantity *
                                Number(selectedRate?.sar_usd)
                            )
                          );
                        }, 0)
                      ).toFixed(2);
                      let frieghtValue = Number(basicValue * 0.2).toFixed(2);
                      let InsuranceValue = Number(basicValue * 0.01125).toFixed(
                        2
                      );
                      let totalValue = Number(
                        Number(basicValue) +
                          Number(frieghtValue) +
                          Number(InsuranceValue)
                      ).toFixed(2);

                      console.log(
                        `Box ${item.box_number}: Total items = ${
                          item.boxe_item?.length || 0
                        }`
                      );
                      console.log(
                        `Box ${item.box_number}: Items data:`,
                        item.boxe_item
                      );

                      const {
                        firstPageItems,
                        remainingItems,
                        hasMultiplePages,
                      } = splitItemsIntoPages(item.boxe_item);

                      console.log(
                        `Box ${item.box_number}: First page items = ${firstPageItems.length}, Remaining items = ${remainingItems.length}, Has multiple pages = ${hasMultiplePages}`
                      );

                      const isLastItem = itemIndex === data.length - 1;

                      return (
                        <React.Fragment key={item.id}>
                          <div
                            className={
                              isLastItem ? "no-page-break" : "page-break"
                            }
                            style={{
                              pageBreakAfter: isLastItem ? "avoid" : "always",
                              breakAfter: isLastItem ? "avoid" : "page",
                            }}
                          >
                            <div
                              className="print-customs-page"
                              style={{
                                height: "max-content",
                                pageBreakInside: "avoid",
                              }}
                            >
                              <table className="print-customs-table">
                                <tr>
                                  <td colSpan={2}>
                                    <div
                                      className="print-customsInvoice-txt1 print-customer-invoice-pdf-txt"
                                      style={{ color: "#000" }}
                                    >
                                      <div>SAHARI INTERNATIONAL</div>
                                      <div>COURIER SERVICES</div>
                                    </div>
                                  </td>
                                  <td
                                    colSpan={4}
                                    className="print-customsInvoice-header"
                                  >
                                    <div
                                      className="print-customer-invoice-pdf-txt"
                                      style={{ color: "#000" }}
                                    >
                                      AIRWAY BILL NO
                                    </div>
                                    <Barcode
                                      value={item.box_number}
                                      height="25"
                                      font="Montserrat-Regular"
                                      fontSize="10px"
                                      width={1}
                                    />
                                  </td>
                                </tr>
                                <tr>
                                  <td colSpan={6}>
                                    <table
                                      style={{ fontSize: "10px" }}
                                      className="print-invoice-table"
                                    >
                                      <tr>
                                        <th
                                          style={{
                                            width: "16.67%",
                                            textAlign: "center",
                                            border:
                                              "1px solid rgb(191, 191, 191)",
                                            padding: "2px",
                                          }}
                                        >
                                          <div
                                            className="print-customsInvoice-txt3 print-customer-invoice-pdf-txt"
                                            style={{ color: "#000" }}
                                          >
                                            DATE
                                          </div>
                                        </th>
                                        <th
                                          style={{
                                            width: "16.67%",
                                            textAlign: "center",
                                            border:
                                              "1px solid rgb(191, 191, 191)",
                                            padding: "2px",
                                          }}
                                        >
                                          <div
                                            className="print-customsInvoice-txt3 print-customer-invoice-pdf-txt"
                                            style={{ color: "#000" }}
                                          >
                                            ORIGIN
                                          </div>
                                        </th>
                                        <th
                                          style={{
                                            width: "16.67%",
                                            textAlign: "center",
                                            border:
                                              "1px solid rgb(191, 191, 191)",
                                            padding: "2px",
                                          }}
                                        >
                                          <div
                                            className="print-customsInvoice-txt3 print-customer-invoice-pdf-txt"
                                            style={{ color: "#000" }}
                                          >
                                            DESTINATION
                                          </div>
                                        </th>
                                        <th
                                          style={{
                                            width: "16.67%",
                                            textAlign: "center",
                                            border:
                                              "1px solid rgb(191, 191, 191)",
                                            padding: "2px",
                                          }}
                                        >
                                          <div
                                            className="print-customsInvoice-txt3 print-customer-invoice-pdf-txt"
                                            style={{ color: "#000" }}
                                          >
                                            REFERENCE NO
                                          </div>
                                        </th>
                                        <th
                                          style={{
                                            width: "16.67%",
                                            textAlign: "center",
                                            border:
                                              "1px solid rgb(191, 191, 191)",
                                            padding: "2px",
                                          }}
                                        >
                                          <div
                                            className="print-customsInvoice-txt3 print-customer-invoice-pdf-txt"
                                            style={{ color: "#000" }}
                                          >
                                            Pieces
                                          </div>
                                        </th>
                                        <th
                                          style={{
                                            width: "16.67%",
                                            textAlign: "center",
                                            border:
                                              "1px solid rgb(191, 191, 191)",
                                            padding: "2px",
                                          }}
                                        >
                                          <div
                                            className="print-customsInvoice-txt3 print-customer-invoice-pdf-txt"
                                            style={{ color: "#000" }}
                                          >
                                            Weight
                                          </div>
                                        </th>
                                        <th
                                          style={{
                                            width: "16.67%",
                                            textAlign: "center",
                                            border:
                                              "1px solid rgb(191, 191, 191)",
                                            padding: "2px",
                                          }}
                                        >
                                          <div
                                            className="print-customsInvoice-txt3 print-customer-invoice-pdf-txt"
                                            style={{ color: "#000" }}
                                          >
                                            Invoice Value
                                          </div>
                                        </th>
                                      </tr>
                                      <tr>
                                        <td
                                          style={{
                                            border:
                                              "1px solid rgb(191, 191, 191)",
                                            padding: "2px",
                                            textAlign: "center",
                                          }}
                                        >
                                          <div
                                            className="print-customsInvoice-txt3 print-customer-invoice-pdf-txt"
                                            style={{ color: "#000" }}
                                          >
                                            {moment(item.createdAt).format(
                                              "DD-MM-YYYY"
                                            )}
                                          </div>
                                        </td>
                                        <td
                                          style={{
                                            border:
                                              "1px solid rgb(191, 191, 191)",
                                            padding: "2px",
                                            textAlign: "center",
                                          }}
                                        >
                                          <div
                                            className="print-customsInvoice-txt3 print-customer-invoice-pdf-txt"
                                            style={{ color: "#000" }}
                                          >
                                            SAUDI ARABIA
                                          </div>
                                        </td>
                                        <td
                                          style={{
                                            border:
                                              "1px solid rgb(191, 191, 191)",
                                            padding: "2px",
                                            textAlign: "center",
                                          }}
                                        >
                                          <div
                                            className="print-customsInvoice-txt3 print-customer-invoice-pdf-txt"
                                            style={{ color: "#000" }}
                                          >
                                            {item?.country?.length > 2
                                              ? item?.country
                                              : item?.collection &&
                                                item?.collection
                                                  ?.recivercountries &&
                                                item?.collection
                                                  ?.recivercountries?.name}
                                          </div>
                                        </td>
                                        <td
                                          style={{
                                            border:
                                              "1px solid rgb(191, 191, 191)",
                                            padding: "2px",
                                            textAlign: "center",
                                          }}
                                        >
                                          <div
                                            className="print-customsInvoice-txt3 print-customer-invoice-pdf-txt"
                                            style={{ color: "#000" }}
                                          >
                                            {item?.box_ref_no
                                              ? item?.box_ref_no
                                              : item?.referance_details
                                              ? item?.referance_details
                                              : ""}
                                          </div>
                                        </td>
                                        <td
                                          style={{
                                            border:
                                              "1px solid rgb(191, 191, 191)",
                                            padding: "2px",
                                            textAlign: "center",
                                          }}
                                        >
                                          <div
                                            className="print-customsInvoice-txt3 print-customer-invoice-pdf-txt"
                                            style={{ color: "#000" }}
                                          >
                                            1
                                          </div>
                                        </td>
                                        <td
                                          style={{
                                            border:
                                              "1px solid rgb(191, 191, 191)",
                                            padding: "2px",
                                            textAlign: "center",
                                          }}
                                        >
                                          <div
                                            className="print-customsInvoice-txt3 print-customer-invoice-pdf-txt"
                                            style={{ color: "#000" }}
                                          >
                                            {item.chargable_weight}
                                          </div>
                                        </td>
                                        <td
                                          style={{
                                            border:
                                              "1px solid rgb(191, 191, 191)",
                                            padding: "2px",
                                            textAlign: "center",
                                          }}
                                        >
                                          <div
                                            className="print-customsInvoice-txt3 print-customer-invoice-pdf-txt"
                                            style={{ color: "#000" }}
                                          >
                                            <b>${totalValue}</b>
                                          </div>
                                        </td>
                                      </tr>
                                    </table>
                                  </td>
                                </tr>
                                <tr>
                                  <td
                                    colSpan={3}
                                    className="print-invoice-table-td"
                                  >
                                    <div
                                      className="print-customsInvoice-txt2 print-customer-invoice-pdf-txt"
                                      style={{ color: "#000" }}
                                    >
                                      DECLARATION
                                    </div>
                                    <div
                                      className="print-invoice-txt5 print-customer-invoice-pdf-txt"
                                      style={{ color: "#000" }}
                                    >
                                      shipper certifies that the nature of goods
                                      is as AIRWAY BILL the shipper agree to and
                                      accept the contract conditions on the
                                      reverse side here of and acknowledges that
                                      the goods described herein is accepted by
                                      SAHARI INTERNATIONAL COURIER SERVICE for
                                      clearance to said contract condition.
                                      shipper declares that goods carried under
                                      this consignmet contain no DANGEROUS
                                      GOODS, as described under the IATA
                                      dangerous goods regulation.
                                    </div>
                                  </td>
                                  <td
                                    colSpan={3}
                                    className="print-invoice-table-td"
                                  >
                                    <div
                                      className="print-invoice-txt5 print-customer-invoice-pdf-txt"
                                      style={{ color: "#000" }}
                                    >
                                      I <b>{item.iqama_name}</b> ID:{" "}
                                      <b>{item.iqama_number}</b>
                                      holder of Indian Passport No/Aadhaar No:
                                      this.props Do here by appointed SAHARI
                                      INTERNAIONAL COURIER SERVICES as my
                                      authorised agent to do the courier
                                      clearance in india for me and sending to{" "}
                                      <b>{item.adhar_name}</b> as a gift
                                      consignment
                                    </div>
                                  </td>
                                </tr>
                                <tr>
                                  <td colSpan={6}>
                                    <div
                                      className="print-invoice-txt4 print-customer-invoice-pdf-txt"
                                      style={{ margin: "5px 0", color: "#000" }}
                                    >
                                      INVOICE/PACKING LIST
                                    </div>
                                  </td>
                                </tr>
                                <tr>
                                  <th
                                    colSpan={3}
                                    className="print-invoice-table-td"
                                    style={{ padding: "3px" }}
                                  >
                                    <div
                                      className="print-customsInvoice-txt4 print-customer-invoice-pdf-txt"
                                      style={{ margin: "2px 0", color: "#000" }}
                                    >
                                      Sender Name & Address
                                    </div>
                                  </th>
                                  <th
                                    colSpan={3}
                                    className="print-invoice-table-td"
                                    style={{ padding: "3px" }}
                                  >
                                    <div
                                      className="print-customsInvoice-txt4 print-customer-invoice-pdf-txt"
                                      style={{ margin: "2px 0", color: "#000" }}
                                    >
                                      Gifts For Personal Use Only
                                    </div>
                                  </th>
                                </tr>
                                <tr>
                                  <td
                                    colSpan={3}
                                    className="print-invoice-table-td"
                                  >
                                    <div
                                      className="print-customs-txt2 print-customer-invoice-pdf-txt"
                                      style={{
                                        margin: "1px 0",
                                        fontSize: "9px",
                                        color: "#000",
                                      }}
                                    >
                                      {item.iqama_name} ID :{item.iqama_number}
                                    </div>
                                    <div
                                      className="print-customs-txt2 print-customer-invoice-pdf-txt"
                                      style={{
                                        margin: "1px 0",
                                        fontSize: "9px",
                                        color: "#000",
                                      }}
                                    >
                                      {item.address}
                                    </div>
                                    <div
                                      className="print-customs-txt2 print-customer-invoice-pdf-txt"
                                      style={{
                                        margin: "1px 0",
                                        fontSize: "9px",
                                        color: "#000",
                                      }}
                                    >
                                      {item.sender_mobile}
                                    </div>
                                    <div
                                      className="print-customsInvoice-txt4 print-customer-invoice-pdf-txt"
                                      style={{
                                        margin: "3px 0 1px 0",
                                        color: "#000",
                                      }}
                                    >
                                      <b>Consignee Name & Address</b>
                                    </div>
                                    <div
                                      className="print-customs-txt2 print-customer-invoice-pdf-txt"
                                      style={{
                                        margin: "1px 0",
                                        fontSize: "9px",
                                        color: "#000",
                                      }}
                                    >
                                      {item.adhar_name}
                                    </div>
                                    <div
                                      className="print-customs-txt2 print-customer-invoice-pdf-txt"
                                      style={{
                                        margin: "1px 0",
                                        fontSize: "9px",
                                        color: "#000",
                                      }}
                                    >
                                      {item.adhar_address}, {item.pin}
                                    </div>
                                    <div
                                      className="print-customs-txt2 print-customer-invoice-pdf-txt"
                                      style={{
                                        margin: "1px 0",
                                        fontSize: "9px",
                                        color: "#000",
                                      }}
                                    >
                                      {item.district}
                                    </div>
                                    <div
                                      className="print-customs-txt2 print-customer-invoice-pdf-txt"
                                      style={{
                                        margin: "1px 0",
                                        fontSize: "9px",
                                        color: "#000",
                                      }}
                                    >
                                      {item.state}
                                    </div>
                                    <div
                                      className="print-customs-txt2 print-customer-invoice-pdf-txt"
                                      style={{
                                        margin: "1px 0",
                                        fontSize: "9px",
                                        color: "#000",
                                      }}
                                    >
                                      {item?.country?.length > 2
                                        ? item?.country
                                        : item?.collection &&
                                          item?.collection?.recivercountries &&
                                          item?.collection?.recivercountries
                                            ?.name}
                                    </div>
                                    <div
                                      className="print-customs-txt2 print-customer-invoice-pdf-txt"
                                      style={{
                                        margin: "1px 0",
                                        fontSize: "9px",
                                        color: "#000",
                                      }}
                                    >
                                      {item.reciver_mobile1}
                                    </div>
                                  </td>
                                  <td
                                    colSpan={3}
                                    className="print-invoice-table-td"
                                  >
                                    <div style={{ display: "flex" }}>
                                      <div className="print-customsInvoice-pod-box">
                                        <div>P</div>
                                        <div>O</div>
                                        <div>D</div>
                                      </div>
                                      <div>
                                        <div
                                          className="print-invoice-txt5 print-customer-invoice-pdf-txt"
                                          style={{
                                            margin: "1px 0",
                                            fontSize: "8px",
                                            color: "#000",
                                          }}
                                        >
                                          I, the undersigned on behalf of the
                                          above sender/shipper acknowledgement
                                          the receipt of goods in good condition
                                        </div>
                                        <div
                                          className="print-customs-txt2 print-customer-invoice-pdf-txt"
                                          style={{
                                            margin: "1px 0",
                                            fontSize: "9px",
                                            color: "#000",
                                          }}
                                        >
                                          <b>Reciever Name :</b>{" "}
                                          {item.adhar_name}
                                        </div>
                                        <div
                                          className="print-customs-txt2 print-customer-invoice-pdf-txt"
                                          style={{
                                            margin: "1px 0",
                                            fontSize: "9px",
                                            color: "#000",
                                          }}
                                        >
                                          <b>Signature :</b>
                                        </div>
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                                <tr>
                                  <td colSpan={6}>
                                    <div className="print-invoice-table-row">
                                      {renderItemsTable(
                                        firstPageItems,
                                        0,
                                        true,
                                        basicValue,
                                        frieghtValue,
                                        InsuranceValue,
                                        totalValue
                                      )}
                                    </div>
                                  </td>
                                </tr>
                                {renderTermsAndConditions(item)}
                                {renderSignatureAndSeal(item)}
                              </table>
                            </div>
                          </div>

                          {hasMultiplePages &&
                            (() => {
                              const itemsPerPage = calculateItemsPerPage(
                                remainingItems.length
                              );
                              const totalRemainingPages = Math.ceil(
                                remainingItems.length / itemsPerPage
                              );

                              return Array.from(
                                { length: totalRemainingPages },
                                (_, pageIndex) => {
                                  const startIndex =
                                    firstPageItems.length +
                                    pageIndex * itemsPerPage;
                                  const currentPageItems = remainingItems.slice(
                                    pageIndex * itemsPerPage,
                                    (pageIndex + 1) * itemsPerPage
                                  );
                                  const isLastSubPage =
                                    pageIndex === totalRemainingPages - 1 &&
                                    isLastItem;

                                  return (
                                    <div
                                      key={`${item.id}-page${pageIndex + 2}`}
                                      className={
                                        isLastSubPage
                                          ? "no-page-break"
                                          : "page-break"
                                      }
                                      style={{
                                        pageBreakAfter: isLastSubPage
                                          ? "avoid"
                                          : "always",
                                        breakAfter: isLastSubPage
                                          ? "avoid"
                                          : "page",
                                      }}
                                    >
                                      <div
                                        className="print-customs-page"
                                        style={{
                                          height: "max-content",
                                          pageBreakInside: "avoid",
                                        }}
                                      >
                                        <table className="print-customs-table">
                                          <tr>
                                            <td colSpan={6}>
                                              <div
                                                className="print-invoice-txt4 print-customer-invoice-pdf-txt"
                                                style={{ color: "#000" }}
                                              >
                                                INVOICE/PACKING LIST BALANCE
                                              </div>
                                            </td>
                                          </tr>
                                          <tr>
                                            <td colSpan={6}>
                                              <div className="print-invoice-table-row">
                                                {renderItemsTable(
                                                  currentPageItems,
                                                  startIndex,
                                                  false,
                                                  basicValue,
                                                  frieghtValue,
                                                  InsuranceValue,
                                                  totalValue
                                                )}
                                              </div>
                                            </td>
                                          </tr>
                                        </table>
                                      </div>
                                    </div>
                                  );
                                }
                              );
                            })()}
                        </React.Fragment>
                      );
                    })}
                </>
              ) : (
                <div className="print-manifest-box1">
                  <AiOutlineCloseCircle size={50} color={"red"} />
                  <div style={{ margin: 20 }} />
                  <div>No data found.</div>
                </div>
              )}
            </>
          )}
        </div>
        {data && data.length ? (
          <Row>
            <Col sm="6"></Col>
            <Col sm="3">
              <ReactToPrint
                trigger={() => (
                  <Button type="primary" block>
                    Print
                  </Button>
                )}
                content={() => componentRef.current}
                pageStyle="@page { size: A4; margin: 0mm; } @media print { body { font-size: 9px; line-height: 1.1; } }"
              />
            </Col>
            <Col sm="3" block>
              <Button onClick={() => props.onClose()}>Cancel</Button>
            </Col>
          </Row>
        ) : null}
      </Modal>
    </div>
  );
}

export default PrintCustomInvoicePdf;
